<template>
  <v-form ref="form" id="form" @submit.prevent="checkSignHandler">
    <v-row align="center">
      <v-col>
        <v-file-input
          prepend-icon="mdi-paperclip"
          outlined
          placeholder="Выберите документ для проверки"
          dense
          v-model="fileInput1"
          hide-details
        />
      </v-col>
      <v-col>
        <v-file-input
          prepend-icon="mdi-paperclip"
          outlined
          placeholder="Выберите сертификат для проверки"
          dense
          v-model="fileInput2"
          hide-details
        />
      </v-col>
      <v-col cols="2">
        <v-btn
          large
          rounded
          class="text-capitalize white--text"
          color="#007AFF"
          width="165"
          :disabled="disabled"
          type="submit"
        >
          Проверить
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
export default {
  name: 'FilesForm',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    file1: {
      type: File,
      default: null
    },
    file2: {
      type: File,
      default: null
    }
  },
  computed: {
    fileInput1: {
      get() {
        return this.file1
      },
      set(value) {
        this.$emit('set-file', '1', value)
      }
    },
    fileInput2: {
      get() {
        return this.file2
      },
      set(value) {
        this.$emit('set-file', '2', value)
      }
    }
  },
  methods: {
    checkSignHandler() {
      this.$emit('check-sign')
    }
  }
}
</script>
